// src/components/Loading.js
import React from 'react';

/**
 * Professional Loading Component
 * @param {string} type - 'full' for full page, 'component' for in-card, 'inline' for small icons
 * @param {string} message - Optional message to display
 */
const Loading = ({ type = 'component', message = '' }) => {
    if (type === 'full') {
        return (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                background: 'rgba(255, 255, 255, 0.85)',
                backdropFilter: 'blur(6px)',
                zIndex: 2000,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                gap: 20
            }}>
                <div className="green-dots">
                    <span></span><span></span><span></span><span></span>
                </div>
                {message && <div style={{ color: '#1976d2', fontWeight: 700, fontSize: 15, letterSpacing: '0.02em' }}>{message}</div>}
            </div>
        );
    }

    if (type === 'inline') {
        return (
            <div className="green-dots" style={{ gap: 3 }}>
                <span style={{ width: 4, height: 4 }}></span>
                <span style={{ width: 4, height: 4 }}></span>
                <span style={{ width: 4, height: 4 }}></span>
            </div>
        );
    }

    return (
        <div style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            padding: '60px 0',
            width: '100%',
            gap: 16
        }}>
            <div className="green-dots">
                <span></span><span></span><span></span><span></span>
            </div>
            {message && <div style={{ color: '#6d7175', fontSize: 13, fontWeight: 500 }}>{message}</div>}
        </div>
    );
};

export default Loading;
